module.exports = __webpack_public_path__ + "img/logo-innovation-lab.e344ae26.png";